import React, { MouseEvent } from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 101;
  background-color: rgba(0, 0, 0, 0.8);
  font-size: ${STYLES.FONT_SIZE_XL};
`

interface IOverlayProps {
  children?: React.ReactNode
  onClick?: (evt: MouseEvent<HTMLElement>) => void
  className?: string
}

const Overlay: React.FC<IOverlayProps> = ({ children, onClick, className }) => (
  <StyledOverlay onClick={onClick} className={className}>
    {children}
  </StyledOverlay>
)

export { Overlay }
